import { createApp } from 'vue'
import App from './Index.vue'
import "./assets/css/animate.css"
import store from './store'
createApp(App).use(store).mount('#app')
console.log(store)
